module.exports = __webpack_public_path__ + "img/benoit22.bdc96ae3.jpg";